














import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import TagHelper from '@/mixins/TagHelper';

@Component
export default class Tags extends mixins(TagHelper) {
  get tagList() {
    // [{"id":"1","name":"空腹"},{"id":"2","name":"饱腹"},{"id":"3","name":"运动后"}]
    return this.$store.state.tagList;
  }

  selectedTag = {};

  created() {
    this.selectedTag = this.tagList[0];
  }

  toggle(tag: string) {
    this.selectedTag = tag;
    this.$emit('update:value', this.selectedTag);
  }
}
